// North-America-centric E.164 normalizer for phone numbers typed by shops
// and customers (customers.phone is free text). Returns null when the input
// cannot be a valid US/CA number; callers decide whether that is an error.
export function normalizeE164(raw) {
    if (!raw)
        return null;
    const trimmed = raw.trim();
    if (!trimmed)
        return null;
    const hasPlus = trimmed.startsWith('+');
    const digits = trimmed.replace(/\D/g, '');
    if (hasPlus) {
        if (digits.length >= 8 && digits.length <= 15)
            return `+${digits}`;
        return null;
    }
    if (digits.length === 10)
        return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1'))
        return `+${digits}`;
    return null;
}
//# sourceMappingURL=phone.js.map